enum StepStatus {
  Pending = "Pending",
  Completed = "Completed",
  Verified = "Verified",
  NotApplicable = "NotApplicable",
  Released = "Released",
  Hold = "Hold",
  Failed = "Failed",
  Cancelled = "Cancelled",
}

export { StepStatus };
